
import { createElement } from "react";
import React from "react";
import { reactElement, reactApi } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { useTranslation } from "react-i18next";
import { createObj } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { ConfirmationDialog } from "../../Components/Dialog.js";
import { Msg } from "./Types.js";
import { join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { DetailViewHeader } from "../../Widgets/DetailViewHeader.js";
import { singleton as singleton_1, ofArray, empty } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { RouterModule_nav } from "../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { empty as empty_1, singleton, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { LabeledValue } from "../../Components/Text.js";
import { Feature, isFeatureEnabled } from "../../FeatureFlip.js";
import { defaultArg } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { update as update_1, initViewLocationView } from "./State.js";
import { Skeleton } from "../../Components/Skeleton.js";

export function LocationDetails(props) {
    let elems_2, Title, elems_1, elems;
    const patternInput = reactApi.useState(false);
    const setIsDeleteDialogOpen = patternInput[1];
    const isDeleteDialogOpen = patternInput[0];
    const t = useTranslation()[0];
    return reactElement("div", createObj(singleton_1((elems_2 = [createElement(ConfirmationDialog, (Title = t("general.remove"), {
        Description: t("location.delete_confirmation"),
        IsOpen: isDeleteDialogOpen,
        OnClose: () => {
            setIsDeleteDialogOpen(false);
        },
        OnConfirm: () => {
            props.Dispatch(new Msg(0, []));
        },
        Title: Title,
    })), reactElement("div", createObj(ofArray([["className", join(" ", ["max-w-[75rem]"])], (elems_1 = [createElement(DetailViewHeader, {
        Badges: empty(),
        OnBack: () => {
            RouterModule_nav(ofArray(["locations"]), 1, 1);
        },
        OnDelete: () => {
            setIsDeleteDialogOpen(!isDeleteDialogOpen);
        },
        OnEdit: () => {
            RouterModule_nav(ofArray(["locations", props.Location.Id, "edit"]), 1, 1);
        },
        Title: t("location.location_details"),
    }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-shrink-0", "flex-col", "mb-3", "bg-white", "rounded", "px-12", "py-9"])], (elems = toList(delay(() => append(singleton(LabeledValue({
        Label: t("general.name"),
        Value: props.Location.Name,
    })), delay(() => append(singleton(LabeledValue({
        Label: t("general.description"),
        Value: props.Location.Description,
    })), delay(() => (isFeatureEnabled(new Feature(17, [])) ? singleton(LabeledValue({
        Label: t("business_units.business_unit"),
        Value: defaultArg(props.Location.BusinessUnitName, ""),
    })) : empty_1()))))))), ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))]))));
}

export function LocationDetailsView(props) {
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(initViewLocationView, update_1, (_arg, _arg_1) => {
    }), props.LocationId, undefined);
    const matchValue = patternInput[0].Location;
    if (matchValue.tag === 0) {
        return createElement(Skeleton, {
            Variant: "detail",
        });
    }
    else {
        return createElement(LocationDetails, {
            Dispatch: patternInput[1],
            Location: matchValue.fields[0],
        });
    }
}

